module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAA5ElEQVR42mNkQAMX3NT0gZQDEBvAsMGuW4wMOAAjUEM8kmIHbIoIGfCfgQAAGYBNHUicegZoLtrHwCYuDZb4++UTw93SWIbv927AFf75/PH/lWBTBp21pxnuN2YzfL10CrsBj3vKGWRLOhk+Ht3N8KApB27AfyC46K7OoL/zJtgCkGFYDYAp+gK0AeQKdAMIeuH73esMnMqaDE+ntzK82bAIxQCYRrwuANn85eJJhpdLpqDYBAoDZh4+sGa8YYDuTJJjgWwDQIBH15Thy+XTWA1ADgOYJdRNSJQYQFlmQhcgNTsDAFvdzRH45UkXAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./ClientApp/images/node-icons/ppt-node.png
// module id = 991
// module chunks = 0